export default "<companies-list [initialCompanies]=\"initialCompanies\"></companies-list>\n";